import { useMemo, useState } from 'react';
import { Col, Collapse } from 'react-bootstrap';
import { BsCaretDownSquareFill, BsCaretUpSquareFill } from 'react-icons/bs';

import styles from '@containers/Dashboard/Dashboard.module.scss';

import { BootstrapTable } from '@components/Table/Table';

export const CollapseBackorder = ({ data }) => {
  const [open, setOpen] = useState(false);
  const columns = useMemo(
    () => [
      { Header: 'Plan', accessor: 'plan__name' },
      { Header: 'Country', accessor: 'country__name' },
      { Header: 'Area', accessor: 'area__name' },
      { Header: 'Type', accessor: 'plan__type__description' },
      { Header: 'Amount', accessor: 'amount' },
    ],
    []
  );
  const caretProps = {
    className: styles.orderDocumentsCaret,
    onClick: () => setOpen(!open),
    'aria-controls': 'collapse-backorders',
    'aria-expanded': open,
  };
  return (
    <>
      <Col className="text-end">
        {open ? (
          <BsCaretUpSquareFill
            className={caretProps.className}
            onClick={caretProps.onClick}
            aria-controls={caretProps['aria-controls']}
            aria-expanded={caretProps['aria-expanded']}
          />
        ) : (
          <BsCaretDownSquareFill
            className={caretProps.className}
            onClick={caretProps.onClick}
            aria-controls={caretProps['aria-controls']}
            aria-expanded={caretProps['aria-expanded']}
          />
        )}
      </Col>
      <Collapse in={open}>
        <div id="collapse-backorders" className="py-1">
          <BootstrapTable
            columns={columns}
            data={data}
            tableProps={() => ({ bordered: true })}
          />
        </div>
      </Collapse>
    </>
  );
};
